import { Tag, VStack } from '@chakra-ui/react';
import iconCompanyAvatar from 'assets/icons/icon-company-avatar.svg';
import EmptyList from 'components/ui/EmptyList';
import { useFormContext } from 'react-hook-form';
import CustomCheckBox from './CustomCheckBox';

export default function SelectLists({ lists }: any) {
  const { setValue, watch } = useFormContext();

  const listIds = watch('listIds') || [];

  if (lists.length > 0)
    return (
      <VStack 
        spacing="20px" 
        alignItems="flex-start"
        px="20px"
        pb="10px"
      >
      { lists.map(list => (
        <CustomCheckBox 
          key={`choice-${list.id}`} 
          name="list"
          value={list.id} 
          isChecked={listIds.includes(list.id)}
          label={list.name}
          description={``}
          onChange={(e) => {
            const newItems = e.target.checked ? [...listIds, e.target.value] : [...listIds.filter(item => item !== e.target.value)];
            setValue('listIds', newItems, { shouldValidate: true });
          }}
        >
          { list.isNewsletter && <Tag colorScheme="green">Newsletter</Tag>}
        </CustomCheckBox>
      ))}
      </VStack>
    );

  return (
      <EmptyList 
        icon={iconCompanyAvatar}
        title="Essa empresa ainda não tem listas"
        description="Você poderá associar o membro a elas depois"
      />
  )
}
